import BaseComponent from '../../base/base_component';
import DOM from '../../utils/dom';
import DateFormatter from '../../utils/date_formatter';
import {SYSTEM_EVENTS} from '../../events/events';
import Event from '../../utils/event';
import { BaseComponentParams } from '../../base/base_component_interface';

/**
 * Display digital current time in several formats (24 and 12 hours)
 * Controller can be used only through directive cgp-directive-clock
 *
 * @attributes
 * data-format - define 24 or 12 hours time display (values: '24h', '12h') Default is 24 hours
 * data-seconds - define if seconds will be displayed (values: 'Y', 'N'). Default is 'N' (not shown)
 *
 * @example
 * 24 hours format without seconds
 * <div class='cgp-directive-clock'></div>
 *
 * 12 hours format with seconds
 * <div class='cgp-directive-clock' data-format='12h' seconds='Y'></div>
 *
 */

interface ClockComponentInitParams extends BaseComponentParams {
  datetime?: string;
}

class ClockComponentController extends BaseComponent {

  static CLASS: string = 'ClockComponentController';
  static DIRECTIVE: string = 'cgp-directive-clock';
  private _datetime: string;
  private _timeClockInterval: number = null;


  init(params: ClockComponentInitParams) {
    super.init(params);
    this._setInitParams(params);
    this._subscribe();
    this.addClass('cy-clock');

  }

  private _subscribe(): void {
    Event.on(SYSTEM_EVENTS.TIME_UPDATED_FROM_SERVER, () => {
      if (this._timeClockInterval) {
        this._updateTime();
      }
    });
  }

  private _setInitParams(params: ClockComponentInitParams): void {
    const dateTimeFormat = this.serviceFactory.skinService().getDateTimeFormat();
    this._datetime = params.datetime ? params.datetime : dateTimeFormat;
  }

  start() {
    if (!this._timeClockInterval) {
      this._timeClockInterval =
          DOM.setInterval(this._updateTime.bind(this), 1000, 'CLOCK_UPDATE_TIMER');
    }
    this._updateTime();
    return this;
  }

  private _updateTime(): void {
    const clockService = this.serviceFactory.clockService();
    const currentDate = clockService.getCurrentDate();
    const currentDateInRegulationTimeZone = clockService.convertToRegulationTimeZone(currentDate);
    if (!currentDateInRegulationTimeZone)
    {
      return;
    }
    const time = DateFormatter.format(currentDateInRegulationTimeZone.date, this._datetime, currentDateInRegulationTimeZone.isUTC);
    const el = this.getEl();
    if (el.innerText !== time) {
      el.innerText = time;
    }
  }

  //Clear timeout
  shutDown() {
    super.shutDown();
    if (this._timeClockInterval) DOM.clearInterval(this._timeClockInterval);
  }
}
export default ClockComponentController;